import { render, staticRenderFns } from "./OfertaServicii.vue?vue&type=template&id=0d4dbd8a&scoped=true"
import script from "./OfertaServicii.vue?vue&type=script&lang=js"
export * from "./OfertaServicii.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4dbd8a",
  null
  
)

export default component.exports